import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import utils from '../../utils/utils';
import { useDeliveryDays } from './apiHooks';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import PackerDeliveryDayRow from './packerDeliveryDayRow';
import Helmet from 'react-helmet';

const PackerDeliveryDays = () => {
  const {
    isLoading: loading,
    deliveryDays,
    isError,
    error,
  } = useDeliveryDays({
    showAll: true,
    sortBy: 'deliveryDateAsc',
    refetchInterval: 10000,
  });
  const { formatMessage } = useIntl();

  return (
    <div className="packer">
      <Helmet>
        <title>{formatMessage({ id: 'packer.delivery.days.title' })}</title>
      </Helmet>
      <h2 className="m-b-6">
        <FormattedMessage id={'packer.delivery.days.title'} />
      </h2>

      <Loader show={loading} />
      {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

      {deliveryDays
        ? deliveryDays.map((deliveryDay, index) => (
            <PackerDeliveryDayRow deliveryDay={deliveryDay} key={index} showMarketplaces={index === 0} />
          ))
        : ''}
    </div>
  );
};

PackerDeliveryDays.propTypes = {};

PackerDeliveryDays.defaultProps = {};

export default PackerDeliveryDays;
